import Callout from './Callout';

export { CalloutVariant, ContentType } from './constants';
export default Callout;
